import GroupSessionServices from "@/services/GroupSessionServices";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
const groupSessionService = new GroupSessionServices();

export const namespaced = true;

export const state = {
  groupSessions: [],
  groupSessionsAlt: [],
  singleGroupSession: {},
  customerGroupSessions: [],
  profGroupSessions: [],
  classCreatedSuccess: false,
  classBookedSuccess: false,
  enrolledCustomers: [],
  currentClassId: "",
  userGroupSessions: [],
  userGroupSessionsAlt: []
};

export const getters = {
  getGroupSessions: state => {
    return state.groupSessions;
  },
  getSingleGroupSession: state => {
    return state.singleGroupSession;
  },
  getProfGroupSessions: state => {
    return state.profGroupSessions;
  },
  getCustomerGroupSessions: state => {
    return state.customerGroupSessions;
  },
  getEnrolledCustomers: state => {
    return state.enrolledCustomers;
  },
  getUserGroupSessions: state => {
    return state.userGroupSessions;
  }
};

export const mutations = {
  updateGroupSessions: (state, payload) => {
    state.groupSessions = payload;
  },
  updateSingleGroupSession: (state, payload) => {
    state.singleGroupSession = payload;
  },
  updateProfGroupSessions: (state, payload) => {
    state.profGroupSessions = payload;
  },
  updateCustomerGroupSessions: (state, payload) => {
    state.customerGroupSessions = payload;
  },
  updateClassBookedSuccess: (state, payload) => {
    state.classBookedSuccess = payload;
  },
  updateClassCreatedSuccess: (state, payload) => {
    state.classCreatedSuccess = payload;
  },
  updateProfGroupSessionsAlt: (state, payload) => {
    state.groupSessionsAlt = payload;
  },
  updateEnrolledCustomers: (state, payload) => {
    state.enrolledCustomers = payload;
  },
  updateCurrentClassId: (state, payload) => {
    state.currentClassId = payload;
  },
  updateUserGroupSessions: (state, payload) => {
    state.userGroupSessions = payload;
  },
  updateUserGroupSessionsAlt: (state, payload) => {
    state.userGroupSessionsAlt = payload;
  }
};

export const actions = {
  createGroupSession({ commit }, payload = GroupSessionRequest.create) {
    let successAction = () => {
      StoreUtils.commit("groupSession/updateClassCreatedSuccess", true);
    };

    return groupSessionService.createGroupSession(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByCustomerId({ commit }, payload = GroupSessionRequest.readByCustomerId) {
    let successAction = responseData => {
      commit("updateCustomerGroupSessions", responseData.data);
    };
    return groupSessionService.readByCustomerId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByGroupSessionId(
    { commit },
    payload = GroupSessionRequest.readByGroupSessionId
  ) {
    let successAction = responseData => {
      commit("updateSingleGroupSession", responseData.data);
    };

    return groupSessionService.readByGroupSessionId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByProfessionalId(
    { commit },
    payload = GroupSessionRequest.readByProfessionalId
  ) {
    let successAction = responseData => {
      commit("updateProfGroupSessions", responseData.data);
      commit("updateProfGroupSessionsAlt", responseData.data);
    };
    return groupSessionService.readByProfessionalId(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  enroll({ commit, payload = GroupSessionRequest.enroll }) {
    let successAction = () => {
      StoreUtils.commit("groupSession/updateClassBookedSuccess", true);
    };

    return groupSessionService.enroll(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readAllGroupSessions({ commit }, payload = {}) {
    let successAction = responseData => {
      commit("updateGroupSessions", responseData.data);
    };

    return groupSessionService.readGroupSessions(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readEnrolledClassCustomers(
    { commit },
    payload = GroupSessionRequest.readEnrolledClassCustomers
  ) {
    let successAction = responseData => {
      StoreUtils.commit(
        "groupSession/updateEnrolledCustomers",
        responseData.data
      );
    };
    return groupSessionService.readEnrolledCustomers(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readUserGroupSessions(
    { commit },
    payload = GroupSessionRequest.readUserGroupSessions
  ) {
    let successAction = responseData => {
      StoreUtils.commit(
        "groupSession/updateUserGroupSessions",
        responseData.data
      );
      StoreUtils.commit(
        "groupSession/updateUserGroupSessionsAlt",
        responseData.data
      );
    };
    return groupSessionService.readGroupSessionsPerUser(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
